<pd-branding [closeMenu]="true" (menuClosed)="menuClosed.emit()" />
<div class="h-full overflow-y-scroll">
  <pd-nav class="menu-root" [menuItems]="menuItems" />
</div>
@if (isDevMode()) {
  <div>
    <p style="padding: 0 0 5px 15px; margin: 0; font-size: 12px; color: gray">v{{version}}</p>
  </div>
}
